import { Component, inject, Signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';

@Component({
  selector: 'app-search-error-dialog',
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose],
  templateUrl: './search-error-dialog.component.html',
  styleUrl: './search-error-dialog.component.scss',
})
export class SearchErrorDialogComponent {
  searchErrors = inject(MAT_DIALOG_DATA) as Signal<string[]>;
}
